import axios from "src/utils/axios";

export function getCurrencies() {
  return axios.get<string[]>("/api/currencies").then((r) => r.data);
}
